import { S as SvgInputError } from './InputError-721475be.js';
import { S as SvgLightBulbTip } from './LightBulbTip-46b25295.js';
import { T as TradeId } from './TradeIcon-c408084b.js';

var iconToComponentMap = {
    inputError: SvgInputError,
    lightBulbTip: SvgLightBulbTip,
};
var tradeNameToIdMap = {
    ductworkCleaning: TradeId.DUCTWORK_CLEANING,
    electrical: TradeId.ELECTRICAL,
    homeAutomation: TradeId.HOME_AUTOMATION,
    hvac: TradeId.HVAC,
    other: TradeId.OTHER,
    plumbing: TradeId.PLUMBING,
    preventativeMaintenance: TradeId.PREVENTATIVE_MAINTENANCE,
    sales: TradeId.SALES,
    service: TradeId.SERVICE,
    solar: TradeId.SOLAR,
};

export { iconToComponentMap as i, tradeNameToIdMap as t };
